/** Design tokens from MISC_SL CALCULATOR DESIGN.pdf mockups */
export const SL_ESTIMATOR_TEAL = '#3a6572';
export const SL_ESTIMATOR_TEAL_HOVER = '#2f535e';
export const SL_ESTIMATOR_TEAL_DARK = '#1e4a56';
export const SL_ESTIMATOR_BLUE = '#2099d2';
export const SL_ESTIMATOR_BLUE_DARK = '#1a7fb0';
export const SL_ESTIMATOR_SELECT_ARROW = '#e5a020';
